module.exports = __webpack_public_path__ + "img/ic-left-menu-home-01.de76ee2f.svg";